export default function resultIsSuccess({ value }) {
  return value === 'Success';
}
